import { endOfDay, isWithinInterval, parseISO } from 'date-fns';

import { USERS_SUMMARY_BASELINE_ISO } from '@/userManagement/domain/constants/usersSummaryBaseline';
import type { AuditLogEntry } from '@/userManagement/domain/entities/AuditLogEntry';

export function isTimestampInUsersSummaryBaseline(timestamp: string): boolean {
  const intervalStart = parseISO(USERS_SUMMARY_BASELINE_ISO);
  const intervalEnd = endOfDay(new Date());
  return isWithinInterval(parseISO(timestamp), { start: intervalStart, end: intervalEnd });
}

/** Lowercased usernames targeted by ModifiedPermission audit rows in the summary baseline window. */
export function collectModifiedPermissionTargetUsernamesInBaseline(auditEntries: AuditLogEntry[]): Set<string> {
  const s = new Set<string>();
  for (const e of auditEntries) {
    if (e.action !== 'ModifiedPermission' || e.targetType !== 'User') continue;
    if (!isTimestampInUsersSummaryBaseline(e.timestamp)) continue;
    const name = e.targetName?.trim();
    if (name) s.add(name.toLowerCase());
  }
  return s;
}
